import { NoParamsKeys } from '@deltasierra/i18n';
import timezonesArray from './timezones.json';

export const timezones = timezonesArray as Array<{ keyId: NoParamsKeys; value: string }>;
